import { Link, useNavigate } from 'react-router-dom'
import { WishlistListSkeleton } from '../components/Skeleton'
import { AUTH_PATHS } from '../constants/auth'
import { WISHLIST_PATHS, WISHLIST_UI } from '../constants/wishlist'
import { formatCurrency } from '../helpers/format'
import { useAuth } from '../hooks/useAuth'
import { useWishlist } from '../hooks/useWishlist'
import '../styles/wishlist-page.scss'

export function WishlistPage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const { items, itemCount, loading, error, remove } = useWishlist()

  if (!isAuthenticated) {
    return (
      <div className="wishlist-page">
        <div className="container">
          <header className="wishlist-page__head">
            <h1>{WISHLIST_UI.pageTitle}</h1>
          </header>
          <div className="wishlist-page__empty">
            <p>{WISHLIST_UI.emptyLoginTitle}</p>
            <p className="wishlist-page__empty-hint">{WISHLIST_UI.emptyLoginHint}</p>
            <Link
              to={AUTH_PATHS.login}
              state={{ from: WISHLIST_PATHS.page }}
              className="wishlist-page__continue"
            >
              {WISHLIST_UI.loginCta}
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="wishlist-page">
      <div className="container">
        <header className="wishlist-page__head">
          <h1>{WISHLIST_UI.pageTitle}</h1>
          {itemCount > 0 ? (
            <p className="wishlist-page__count">
              {itemCount}{' '}
              {itemCount === 1 ? WISHLIST_UI.itemSingular : WISHLIST_UI.itemPlural}
            </p>
          ) : null}
        </header>

        {error ? <p className="wishlist-page__error">{error}</p> : null}

        {loading && items.length === 0 ? (
          <WishlistListSkeleton />
        ) : items.length === 0 ? (
          <div className="wishlist-page__empty">
            <p>{WISHLIST_UI.emptyTitle}</p>
            <p className="wishlist-page__empty-hint">{WISHLIST_UI.emptyHint}</p>
            <Link to="/" className="wishlist-page__continue">
              {WISHLIST_UI.continueShopping}
            </Link>
          </div>
        ) : (
          <ul className="wishlist-lines">
            {items.map((item) => (
              <li key={item.id} className="wishlist-line">
                <Link
                  to={`/product/${item.product.slug}`}
                  className="wishlist-line__media"
                >
                  {item.product.imageUrl ? (
                    <img src={item.product.imageUrl} alt="" />
                  ) : (
                    <span className="wishlist-line__placeholder" aria-hidden />
                  )}
                </Link>

                <div className="wishlist-line__body">
                  <Link
                    to={`/product/${item.product.slug}`}
                    className="wishlist-line__name"
                  >
                    {item.product.name}
                  </Link>
                  <p className="wishlist-line__price">
                    {formatCurrency(item.product.displayPrice)}
                    {item.product.compareAtPrice != null ? (
                      <span className="wishlist-line__compare">
                        {formatCurrency(item.product.compareAtPrice)}
                      </span>
                    ) : null}
                  </p>
                  <div className="wishlist-line__actions">
                    <button
                      type="button"
                      className="wishlist-line__cta"
                      onClick={() => navigate(`/product/${item.product.slug}`)}
                    >
                      {WISHLIST_UI.addToCart}
                    </button>
                    <button
                      type="button"
                      className="wishlist-line__remove"
                      onClick={() => void remove(item.productId)}
                    >
                      {WISHLIST_UI.remove}
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
